module.exports = function() {
  return new Worker(__webpack_public_path__ + "685dbad8e11fdbda638e.worker.js");
};